import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonVariablesService } from '../common-variables.service';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-policy-enable',
  templateUrl: './policy-enable.component.html',
  styleUrls: ['./policy-enable.component.css']
})
export class PolicyEnableComponent implements OnInit {

  policyEnableForm: FormGroup;
  getUserType:any;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.policyEnableForm = this.formBuilder.group({
      policy_number: ['', [Validators.required,Validators.minLength(10)]],
      reference_number: ['', [Validators.required, Validators.minLength(15)]],
    });

    /* let tmpUserType = this.cookie.get('userProfile'); */
    let tmpUserType = window.localStorage.getItem('userProfile');
    this.getUserType = this.commonService.decryptData(tmpUserType);
  }

  get f() { return this.policyEnableForm.controls; }


  /*
	 * Created By : Balbir Kaur
	 * Description : allow only numbers
	 *********************************************/
	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
 
 /*
  * Created By : Balbir Kaur
  * Description : This function will reset the form.
  *********************************************/

  resetForm() {
    this.policyEnableForm.reset();
    this.submitted = false;
  }
  /*
  * Created By : Balbir Kaur
  * Description : enable the policy.
  *********************************************/
  async enablePolicy() {
    this.spinner.show();
    if (this.policyEnableForm.invalid) {
      this.submitted = true;
      this.spinner.hide();
      return false;
    }
    else {
      let param = {
        "policy_ref_num" : this.policyEnableForm.controls.reference_number.value,
        "policy_number" : this.policyEnableForm.controls.policy_number.value,
       
      }
     if (this.getUserType == "admin" || this.getUserType == "hub") {
        //await this.selectChannelType([])   //Priyadharshini - Channel Type
        /***************ragu */
       let url = `${this.commonVariablesService.baseURL}api/v1/marine_mp_gc_data/activatePolicy`;
  
        let response = await this.commonService.httpPostMethod(
          url,
          param,
          "application/json",
          true,
          "Declaration"
        );
        if (response.body.status == 0) {
          this.spinner.hide();
          this.commonService.successmsg(response.body.data,"")
          } else if (response.body.status == -102) {
          this.spinner.hide();
          this.commonService.errorsmsg(response.body.txt,"");
         }
         else{
          this.spinner.hide();
          this.commonService.errorsmsg(response.body.txt,"");
        }
      }
    }
  }
}
